// AUTO-GENERATED by scripts/gen-build-info.js — do not edit.
export const BUILD_INFO = { sha: '2f4160c', builtAt: '2026-10-23 14:56 UTC' };
